export default __webpack_public_path__ + "static/media/g_wdt_c_1.2395deac.mp3";